import { EligibilityResult } from "../services/CareScreenerService";

type FetchEligibilityResult = (id: number) => Promise<EligibilityResult>;

export type EligibilityPollResult = EligibilityResult | { status: "TIMEOUT" };

export async function pollEligibilityResult(
  submissionId: number,
  fetchResult: FetchEligibilityResult,
  options: { pollIntervalMs?: number; timeoutMs?: number } = {}
): Promise<EligibilityPollResult> {
  const { pollIntervalMs = 2000, timeoutMs = 45000 } = options;
  const start = Date.now();

  for (;;) {
    if (Date.now() - start >= timeoutMs) {
      return { status: "TIMEOUT" };
    }

    try {
      const result = await fetchResult(submissionId);
      if (result.status !== "PENDING") {
        return result;
      }
    } catch {
      // swallow network errors and keep polling
    }

    await new Promise(resolve => setTimeout(resolve, pollIntervalMs));
  }
}
